<script>
import common from "@/mixins/common";
import {mapActions, mapGetters} from 'vuex';
export default {
  name: "vendor",
  mixins: [common],
  data(){
    return {
      itemDetail: {
        vendorId: '',
        name:'',
        logoUrl:'',
        intro:'',
        line:'',
        email:'',
        cellphone:'',
      },
      saveLoading: false,
    }
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    getDialogKeys() {
      return [
        {value: 'name', text: '名稱', disable:true},
        {value: 'logoUrl', text: 'Logo圖片網址', editorOption: {
            placeholder:'Logo圖片網址'
          },},
        {value: 'intro', text: '介紹', editorOption: {
            placeholder:'介紹'
          },},
        {value: 'line', text: 'Line ID', editorOption: {
            placeholder:'Line ID'
          },},
        {value: 'email', text: '聯絡信箱', editorOption: {
            placeholder:'聯絡信箱'
          },
        },
        {value: 'cellphone', text: '聯絡電話(選填)', editorOption: {
            placeholder:'聯絡電話(選填)'
          },
        },
        {value: 'pickupAvailable', text: '是否提供買家自取', editorOption: {
            type: 'checkbox'
          },
        },
        {value: 'address', text: '取貨地址(若提供買家自取則為必填)', editorOption: {
            placeholder:'地址(選填)'
          },
        },
        {value: 'companyId', text: '統編(選填)', editorOption: {
            placeholder:'統編(選填)'
          },
        },
        {value: 'companyName', text: '公司名稱(選填)', editorOption: {
            placeholder:'公司名稱(選填)'
          },
        },
      ];
    },
  },
  methods: {
    ...mapActions(['getVendorInfo', 'saveVendorInfo', 'getCacheUserInfo']),
    async loadData(){
      try {
        this.loading = true;
        const user = await this.getCacheUserInfo();
        console.log(`getCacheUserInfo == ${JSON.stringify(user)}`);
        if (!user) return;

        const res = await this.getVendorInfo({vendorId: user.userId });
        const result = res.data;
        if (result && result.statusCode === 0){
          this.itemDetail = result.data;
          console.log(`getVendorInfo ${JSON.stringify(this.itemDetail)}`);
        } else {
          this.itemDetail = {
            vendorId: this.getUserInfo.userId,
            name: this.getUserInfo.vendorName,
            logoUrl:'',
            intro:'',
            line:'',
            email: this.getUserInfo.email,
            cellphone:'',
            address: '',
            companyName: '',
            companyId: ''
          };
        }
      } catch (e) {
        console.log(`getVendorInfo error `, e);
      } finally {
        this.loading = false;
      }
    },
    async saveData(){
     try {
       this.saveLoading = true;
       console.log(`save ${JSON.stringify(this.itemDetail)}`);
       const res = await this.saveVendorInfo(this.itemDetail);
       const result = res.data;
       if (result && result.statusCode === 0) {
         this.showMessageDialog('成功', '儲存成功');
       } else {
         this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
       }
       this.saveLoading = false;
     }catch (e) {
       console.log(`saveVendorInfo error `, e);
     } finally {
       this.saveLoading = false;
     }
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
  }
}
</script>

<template>
  <v-layout>
    <v-flex md5 sm12>
      <v-card>
        <v-card-title>商店設定</v-card-title>
        <v-card-text>
          <v-layout v-for="col in getDialogKeys" :key="col.value">
            <v-flex>
<!--              <br/><span class="title" v-if="col.editorOption">{{col.editorOption.placeholder}}</span><br/>-->
              <v-textarea v-if="col.value === 'content'"
                            class="mb-2 mt-2"
                            v-model="itemDetail[col.value]"
              />
              <v-checkbox v-if="col.editorOption && col.editorOption.type === 'checkbox'"
                  v-model="itemDetail[col.value]"
                  :label="col.text"></v-checkbox>
              <v-text-field v-else v-model="itemDetail[col.value]"
                            :label="col.text"
                            :disabled="col.disable"
                            :color="Theme.GREEN"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="saveData">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<style scoped>

</style>
